module.exports = __webpack_public_path__ + "img/AW.defa42fd.svg";